import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <section className="w-full bg-mist py-14 md:py-20" aria-labelledby="guarantee-title" data-id="element-158" data-mp="20m4qnvskykwl">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-159" data-mp="24mew97cgn9ax">
        <div className="rounded-3xl border border-brand-500/25 bg-white px-5 py-8 text-center shadow-card sm:px-8" data-id="element-160" data-mp="29dwzk21yhlz2">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand-100" data-id="element-161" data-mp="2edjb8724yu5r">
            <ShieldCheckIcon className="h-8 w-8 text-brand-600" aria-hidden="true" data-id="element-162" data-mp="2jbbc3qkrdqm3" />
          </span>

          <p className="mt-5 font-display text-[11px] font-black uppercase tracking-[0.2em] text-brand-600" data-id="element-163" data-mp="2oaxnduh10ws9">
            100% risk-free guarantee
          </p>
          <h2 id="guarantee-title" className="mt-2 font-display text-[22px] font-black uppercase leading-tight text-navy-950 sm:text-3xl" data-id="element-164" data-mp="2sag8aq8ul7v3">
            Try Aligner Case Commander™ for 7 days
          </h2>

          <p className="mt-4 text-[15px] leading-relaxed text-navy-800/80" data-id="element-165" data-mp="3smhxqm0jtty2">
            Explore the complete system for 7 days. If you decide that ALIGNER CASE COMMANDER™ isn’t the
            right fit for the way you organize your professional workflow, you can request a refund
            according to the terms of the offer.
          </p>

          <ul className="mx-auto mt-5 flex max-w-sm flex-col gap-1.5 text-[13px] font-semibold text-navy-900" data-id="element-166" data-mp="3duft6onjacrp">
            <li data-id="element-167" data-mp="aftu70l5deui">No long-term commitment.</li>
            <li data-id="element-168" data-mp="agv6t9hta9ec">No subscription.</li>
            <li data-id="element-169" data-mp="adqshjamtx9y">One-time payment.</li>
          </ul>

          <div className="mt-7" data-id="element-170" data-mp="5fxmaq9bx39o">
            <CTAButton data-id="element-171" data-mp="5ew29wac56ft" />
          </div>
        </div>
      </div>
    </section>;
}